import { preRender } from './axes.prerender';
import {
  alignXAxisLabels,
  drawZeroLine,
  shortenMinorTicks,
  setGridLineStartAndSuffix,
} from './axes.onload';

export { preRender, alignXAxisLabels, drawZeroLine, shortenMinorTicks, setGridLineStartAndSuffix };
